<!-- Common header-->
<app-header extraClass="text-gray nav-down" displayNavigation=true></app-header>

<section class="experience-wrp search-result mt-6">
  <div class="container">

    <ng-container *ngIf="responseReceived && products.length > 0">
      <div class="heading-text-wrp text-center">
        <h5>Results for <span>"{{this.selectedKeyword}}"</span></h5>
        <div class="line"></div>
      </div>
      <div class="listing-card" *ngFor="let product of products">
        <div class="imageVideo">
          <div class="image">
            <div class="video">
              <video class="vdo" inViewport [inViewportOptions]="{ threshold: [0] }"
                     (inViewportAction)="onVideoIntersection($event)"
                     poster="{{product.preview_video_image}}"
                     src="{{product.video}}#t=0.1" loop="1" preload="none" muted=""
                     (mouseover)="playVideo($event.target)"
                     (mouseout)="pauseVideo($event.target)"></video>
            </div>
            <div class="voice">
              <img src="assets/images/icons/sound.png" alt="" class="volumecontrol hidelg"
                   (click)="videoVolumeControl($event.target)">
            </div>
          </div>
        </div>
        <div class="details" (click)="showProductDetail(product)">
          <span>{{product.category?.category_name}} </span>
          <h4>{{product.title}} </h4>
          <p>{{product.short_description}}</p>
          <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]"
             class="btn-yellow btn-yellow-bold center-block">Book
            Now</a>
        </div>
      </div>
      <div class="pagination showpagination" *ngIf="response?.last_page >1">
        <ul class="uk-pagination uk-flex-center" uk-margin>
          <li class="uk-first-column"><a href="javascript:void(0)" (click)="goToPage(response.current_page - 1)"><span
            uk-pagination-previous></span></a></li>
          <li *ngFor="let i of pages" [ngClass]="{'uk-active' : i == response.current_page}"><a
            href="javascript:void(0)"
            (click)="goToPage(i)"><span
            *ngIf="i<10">0</span> {{i}} </a></li>
          <li><a href="javascript:void(0)" (click)="goToPage(response.current_page + 1)"><span
            uk-pagination-next></span></a>
          </li>
        </ul>
      </div>
    </ng-container>


    <ng-container *ngIf="responseReceived && products.length === 0">
      <div class="heading-text-wrp text-center">
        <h5>No Results found for <span>"{{this.selectedKeyword}}"</span></h5>
        <div class="line"></div>
      </div>
    </ng-container>


  </div>

</section>

<app-footer></app-footer>
